<template>
	<div class="eMigrate_application">
	 <img :src="item" alt="">
	</div>
</template>

<script>
export default {
	name: "EMigrateApplication",
	data(){
		return {
			item:require('@/assets/eMigrate/eMigrate-application/7.png'),
			first: require('@/assets/eMigrate/eMigrate-application/4.png'),
			second: require('@/assets/eMigrate/eMigrate-application/3.png'),
			third: require('@/assets/eMigrate/eMigrate-application/2.png'),
			fourth: require('@/assets/eMigrate/eMigrate-application/1.png'),
      active: 'div1',
		}
	},
	methods:{
    tabOnmouseover(name) {
      this.active = name
    }
	},
	created() {

	},
	computed:{
	},
	watch:{

	},

}
</script>

<style lang="scss" scoped>
.active {
  transition: width 1.3s;
  width: 556px !important;
}
.divider {
  margin-left: 41px;
  margin-top: 12.25px;
  width: 46px;
  height: 6px;
  opacity: 1;
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);

}
.eMigrate_application{
	padding-top: 71px;
	width: 1920px;
	height: 895px;
	// background: rgba(245, 248, 255, 1);
	img{
		width: 100%;
	}
	.eMove_application_p{
		width: 100%;
		height: 47px;
		opacity: 1;
		/** 文本1 */
		font-size: 31.92px;
		font-weight: 700;
		letter-spacing: 0;
		line-height: 46.22px;
		color: rgba(34, 34, 34, 1);
		text-align: center;
		vertical-align: top;
	}
	.eMove_application_wrap{
		width: 1920px;
		height: 501px;
		margin-top: 33px;
		/* 子元素居中 */
		display: flex;
		justify-content: center; /* 子元素水平居中 */
		.eMove_application_wrap_div{
      margin-left: 250px;
			width: 1920px;
			height: 501px;
			.eMove_application_div1{
				float: left;
				margin-right: 1px;
				position: relative;
				width: 280px;
				height: 501px;
				.eMove_application_div1_backtground{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div1_backtground_img{
						width: 100%;
						height: 501px;
					}
				}
				.eMove_application_div1_wrap{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div1_wrap_p1{
						margin-top: 368px;
						margin-left: 41px;
						width: 100%;
						height: 23.94px;
						opacity: 1;
						/** 文本1 */
						font-size: 15.96px;
						font-weight: 400;
						letter-spacing: 0;
						line-height: 23.11px;
						color: rgba(255, 255, 255, 1);
						text-align: left;
						vertical-align: top;
					}
					.eMove_application_div1_wrap_p2{
						margin-left: 40px;
						margin-top: 12px;
						width: 390.98px;
						height: 42.89px;
						opacity: 1;
						/** 文本1 */
						font-size: 13.96px;
						font-weight: 300;
						letter-spacing: 0;
						line-height: 20.22px;
						color: rgba(255, 255, 255, 1);
						text-align: left;
						vertical-align: top;
					}
				}
			}
			.eMove_application_div2{
				float: left;
				margin-right: 1px;
				position: relative;
				width: 280px;
				height: 501px;
				.eMove_application_div2_backtground{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div2_backtground_img{
						width: 100%;
						height: 501px;
					}
				}
				.eMove_application_div2_wrap{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div2_wrap_p1{
						margin-top: 368px;
						margin-left: 41px;
						width: 100%;
						height: 23.94px;
						opacity: 1;
						/** 文本1 */
						font-size: 15.96px;
						font-weight: 400;
						letter-spacing: 0px;
						line-height: 23.11px;
						color: rgba(255, 255, 255, 1);
						text-align: left;
						vertical-align: top;
					}
          .eMove_application_div2_wrap_p2{
            margin-left: 40px;
            margin-top: 12px;
            width: 390.98px;
            height: 42.89px;
            opacity: 1;
            /** 文本1 */
            font-size: 13.96px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 20.22px;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            vertical-align: top;
          }
				}
			}
			.eMove_application_div3{
				float: left;
				margin-right: 1px;
				position: relative;
				width: 280px;
				height: 501px;
				.eMove_application_div3_backtground{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div3_backtground_img{
						width: 100%;
						height: 501px;
					}
				}
				.eMove_application_div3_wrap{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div3_wrap_p1{
						margin-top: 368px;
						margin-left: 41px;
						width: 100%;
						height: 23.94px;
						opacity: 1;
						/** 文本1 */
						font-size: 15.96px;
						font-weight: 400;
						letter-spacing: 0;
						line-height: 23.11px;
						color: rgba(255, 255, 255, 1);
						text-align: left;
						vertical-align: top;
					}
          .eMove_application_div3_wrap_p2{
            margin-left: 40px;
            margin-top: 12px;
            width: 390.98px;
            height: 42.89px;
            opacity: 1;
            /** 文本1 */
            font-size: 13.96px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 20.22px;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            vertical-align: top;
          }
				}
			}
			.eMove_application_div4{
				float: left;
				position: relative;
				width: 280px;
				height: 501px;
				.eMove_application_div4_backtground{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div4_backtground_img{
						width: 100%;
						height: 501px;
					}
				}
				.eMove_application_div4_wrap{
					position: absolute;
					width: 100%;
					height: 501px;
					.eMove_application_div4_wrap_p1{
						margin-top: 368px;
						margin-left: 41px;
						width: 100%;
						height: 23.94px;
						opacity: 1;
						/** 文本1 */
						font-size: 15.96px;
						font-weight: 400;
						letter-spacing: 0;
						line-height: 23.11px;
						color: rgba(255, 255, 255, 1);
						text-align: left;
						vertical-align: top;
					}
          .eMove_application_div4_wrap_p2{
            margin-left: 40px;
            margin-top: 12px;
            width: 390.98px;
            height: 42.89px;
            opacity: 1;
            /** 文本1 */
            font-size: 13.96px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 20.22px;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            vertical-align: top;
          }
				}
			}
		}
	}
}
</style>